import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import { Box, Slider } from '@mui/material';
import React from 'react';

type Props = {
  disabled: boolean;
  marks?: { label?: string; value: number }[] | boolean;
  max: number;
  min: number;
  name?: string;
  onChange?: (event: Event, value: number[] | number) => void;
  step?: number;
  value: number;
};

export const SliderUi: React.FC<Props> = props => {
  const { step } = props;
  // Used for skill levels and quiz scale questions, so the label stays generic
  const { t } = useTranslationWithPrefix('components.slider');

  return (
    <Box className="px-3">
      <Slider
        {...props}
        aria-label={t('ariaLabel')}
        size="small"
        step={step ?? 1}
        sx={{
          '&.Mui-disabled': {
            '& .MuiSlider-rail': {
              background: '#e8e8e8',
            },
            '& .MuiSlider-track': {
              background: '#ccc',
            },
            color: '#ccc',
          },
          '& .MuiSlider-mark': {
            '&.MuiSlider-markActive': {
              backgroundColor: 'rgba(255,255,255,0.7)',
            },
            backgroundColor: '#bbb',
            borderRadius: '50%',
            height: '8px',
            top: '50%',
            transform: 'translateX(-50%) translateY(-50%)',
            width: '8px',
          },
          '& .MuiSlider-rail': {
            background: 'linear-gradient(to right, #e0e0e0, #d0d0d0)',
            borderRadius: '3px',
            height: '6px',
            opacity: 1,
          },
          '& .MuiSlider-thumb': {
            '&::before': {
              display: 'none',
            },
            '&:hover': {
              background: '#f16e00',
              borderColor: '#f16e00',
              boxShadow: '0 2px 8px rgba(241, 110, 0, 0.3)',
            },
            '&.Mui-active': {
              background: '#f16e00',
              borderColor: '#f16e00',
              boxShadow: '0 2px 12px rgba(241, 110, 0, 0.4)',
            },
            '&.Mui-disabled': {
              background: '#e0e0e0',
              borderColor: '#ccc',
            },
            '&.Mui-focusVisible': {
              boxShadow: '0 0 0 4px rgba(241, 110, 0, 0.2)',
            },
            background: '#f16e00',
            border: 'none',
            boxShadow: '0 2px 6px rgba(241, 110, 0, 0.3)',
            height: 20,
            transition: 'all 0.15s ease',
            width: 20,
          },
          '& .MuiSlider-track': {
            background: '#f16e00',
            border: 'none',
            borderRadius: '3px',
            height: '6px',
          },
          height: 6,
          padding: '13px 0',
          paddingX: '',
        }}
      />
    </Box>
  );
};
